import React, {useEffect, useState} from "react";
import { Button, Container, Grid, TextField, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { DayOfWeekMap } from "../utils/constants";
import moment from "moment";

export const NewAssignmentForm = ({submit, solutions, stations}) => {

  const [newAssignment, setNewAssignment] = useState({stationId: "", startTime: "", SolutionId: "", DayOfWeek: ""});
  const fullReset = false;

  const setProperty = (target, value) => {
    setNewAssignment({...newAssignment, [target]: value});
  }

  const create = async () => {
    // let toSend = {...newAssignment, startTime: moment.duration(newAssignment.startTime, "hours")}
    let retVal = await submit(newAssignment);
    let resetVal = (fullReset) ? {stationId: '', SolutionId: "", DayOfWeek: "", startTime: ""} : 
      {...newAssignment, startTime: "", stationId: ""}
    if (retVal){
      setNewAssignment(resetVal);
    }
  }

  const stationCompare = (a, b) => {
    if (a.name < b.name){
      return -1;
    }else if(a.name > b.name){
      return 1;
    }else{
      return 0;
    }
  }


  return (
    <Grid container spacing={1} justifyContent={"center"}>
      <Grid item xs={6}>
        <FormControl fullWidth>
        <InputLabel id="station-label">Station Name</InputLabel>
        <Select 
          label="Station"
          labelId="station-label"
          value={newAssignment.stationId}
          onChange={(e) => setProperty("stationId", e.target.value)}
          id="station-name-select"
        >
          {stations.sort(stationCompare).map(s => 
            <MenuItem value={s.id} key={s.id}>{s.name}</MenuItem>
          )}

        </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl fullWidth>
        <InputLabel id="sol-label">Solution Name</InputLabel>
        <Select 
          label="Solution Name"
          labelId="sol-label"
          value={newAssignment.SolutionId}
          onChange={(e) => setProperty("SolutionId", e.target.value)}
          sx = {{width: "50%"}}
        >
          {solutions.map(s => 
            <MenuItem value={s.id} key={s.id}>{s.name}</MenuItem>
          )}
        </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl fullWidth>
        <InputLabel id="dow-label">Day Of Week</InputLabel>
        <Select 
          label="Day Of Week"
          labelId="dow-label"
          value={newAssignment.DayOfWeek}
          onChange={(e) => setProperty("DayOfWeek", e.target.value)}
          fullWidth
        >
          {Object.keys(DayOfWeekMap).map(key => 
            <MenuItem value={DayOfWeekMap[key]} key={key}>{key}</MenuItem>
          )}
        </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <TextField 
          label="Start Hour"
          type="number"
          inputProps={{min: 0, max: 24}}
          value={newAssignment.startTime}
          onChange={(e) => setProperty("startTime", e.target.value)}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <Button fullWidth onClick={create}>
          Submit
        </Button>
      </Grid>
    </Grid>
  )

  //needs Station, StartTime, DoW, Solution

}